import React, { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { api } from "../lib/apiClient";
import { useAuth } from "../context/AuthContext";
import { Loader2 } from "lucide-react";

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = location.hash || window.location.hash;
    const sessionId = new URLSearchParams(hash.replace("#", "")).get("session_id");
    if (!sessionId) {
      navigate("/admin", { replace: true });
      return;
    }
    (async () => {
      try {
        const res = await api.post("/auth/session", null, { headers: { "X-Session-ID": sessionId } });
        setUser({ ...res.data, is_admin: true });
        window.history.replaceState(null, "", "/admin/dashboard");
        navigate("/admin/dashboard", { replace: true, state: { user: res.data } });
      } catch (e) {
        navigate("/admin", { replace: true, state: { error: e.response?.data?.detail || "Accès refusé." } });
      }
    })();
  }, [location.hash, navigate, setUser]);

  return (
    <div className="min-h-screen grid place-items-center bg-background">
      <div className="flex flex-col items-center gap-3 text-slate-500">
        <Loader2 className="w-8 h-8 animate-spin text-primary" />
        <p className="text-sm">Connexion en cours…</p>
      </div>
    </div>
  );
}
